import { render, staticRenderFns } from "./TabelDinamis.vue?vue&type=template&id=682583c0"
import script from "./TabelDinamis.vue?vue&type=script&lang=js"
export * from "./TabelDinamis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports